export const marie = 'Marie';
export const anywize = 'Anywize';